import { css } from 'lit';
import { errorClassName } from '../../shared/styles/form-control.styles.js';
export const oneTimeCodeStyles = css `
    :host {
        display: block;
    }

    .hlx-one-time-code {
        display: flex;
        flex: 1 1 auto;
        gap: var(--hlx-spacing-xs);
        align-items: stretch;
        justify-content: start;
        position: relative;
        height: var(--hlx-spacing-5xl);
        width: 100%;
        overflow: hidden;
        cursor: text;
    }

    .hlx-one-time-code-control {
        flex: 1 1 auto;
        background-color: var(--hlx-input-background-color-default);
        border: solid 1px var(--hlx-input-border-color-default);
        border-radius: var(--hlx-spacing-2xs);
        font-family: var(--hlx-text-font-family-sans-serif);
        font-weight: var(--hlx-text-font-weight-normal);
        letter-spacing: var(--hlx-text-letter-spacing-default);
        line-height: var(--hlx-text-line-height-tight-1);
        font-size: var(--hlx-text-font-size-md);
        height: calc(var(--hlx-spacing-5xl) - border-width * 2);
        padding: 0 var(--hlx-spacing-md);
        vertical-align: middle;
        text-align: center;
        min-width: 0;
        color: var(--hlx-color-neutral-70);
        box-shadow: none;
        padding: 0;
        margin: 0;
        cursor: inherit;
        caret-color: transparent;
        -webkit-appearance: none;
    }

    .hlx-one-time-code-control:hover:not(
            .hlx-one-time-code-control-disabled,
            .hlx-one-time-code-control-readonly
        ) {
        outline: solid 2px var(--hlx-input-border-color-default);
        outline-offset: -2px;
    }
    .hlx-one-time-code-control:focus:not(.hlx-one-time-code-control-disabled) {
        border-color: var(--hlx-color-brand-default);
        outline: solid 2px var(--hlx-color-brand-default);
        outline-offset: -2px;
    }

    .${errorClassName} .hlx-one-time-code-control {
        border: 2px solid var(--hlx-input-border-color-error);
    }
    .${errorClassName} .hlx-one-time-code-control:hover:not(.hlx-one-time-code-control-disabled) {
        outline: solid 2px var(--hlx-input-border-color-default);
        outline-offset: -2px;
    }
    .${errorClassName} .hlx-one-time-code-control:focus:not(.hlx-one-time-code-control-disabled) {
        border-color: var(--hlx-color-brand-default);
        outline: solid 2px var(--hlx-color-brand-default);
        outline-offset: -2px;
    }

    .hlx-one-time-code-control.hlx-one-time-code-control-disabled {
        background-color: var(--hlx-input-background-color-disabled);
        border-color: var(--hlx-input-border-color-default);
        color: var(--hlx-input-text-color-disabled);
        cursor: not-allowed;
    }
    .hlx-one-time-code-control.hlx-one-time-code-control-disabled::placeholder {
        color: var(--hlx-input-placeholder-text-color-disabled);
    }

    .hlx-one-time-code-control.hlx-one-time-code-control-readonly {
        background-color: var(--hlx-input-background-color-disabled);
        border-color: var(--hlx-input-border-color-default);
        cursor: not-allowed;
    }
    .hlx-one-time-code-control.hlx-one-time-code-control-readonly::placeholder {
        color: var(--hlx-input-placeholder-text-color-readonly);
    }

    .hlx-one-time-code-control::selection {
        background: transparent;
    }

    .hlx-one-time-code-control::placeholder {
        color: var(--hlx-input-placeholder-text-color-default);
        font-weight: var(--hlx-text-font-weight-normal);
        user-select: none;
    }
`;
//# sourceMappingURL=one-time-code.styles.js.map